import React, { useEffect, useState } from "react";
import { CalendarRange, ExternalLink, Share2, ThumbsUp } from "lucide-react";
import { fmtD } from "../lib/date";
import { pickSummary } from "../lib/ownerI18n";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

// 业主门户 · 进展周报列表（每周日生成；独立分享链接可转发家人）
export const OwnerWeeklyList = ({ token, lang = "zh", T }) => {
  const [items, setItems] = useState(null);
  useEffect(() => {
    fetch(`${BACKEND}/api/public/owner-hub/${token}/weekly?lang=${lang}`).then((r) => (r.ok ? r.json() : { items: [] })).then((d) => setItems(d.items || [])).catch(() => setItems([]));
  }, [token, lang]);
  if (!items?.length) return null;
  return (
    <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-4" data-testid="owner-weekly-list" data-count={items.length}>
      <p className="text-sm font-bold text-slate-800 mb-3 flex items-center gap-1.5"><CalendarRange className="h-4 w-4 text-red-600" />{T("进展周报", "Weekly Recaps")}<span className="text-[10px] text-slate-400 font-normal">{T("每周日生成 · 可转发家人", "every Sunday · shareable")}</span></p>
      <div className="space-y-2">
        {items.map((w) => (
          <a key={w.id} href={w.shareUrl} target="_blank" rel="noreferrer" data-testid={`owner-weekly-${w.weekStart}`} className="flex gap-3 rounded-xl border border-slate-100 hover:border-brand-200 hover:bg-brand-50/30 p-2.5 transition-colors">
            {w.collageId ? <img src={`${BACKEND}/api/public/weekly/${w.shareUrl.split("/w/")[1]}/file/${w.collageId}`} alt="" className="h-16 w-16 rounded-lg object-cover shrink-0 bg-slate-100" loading="lazy" /> : <div className="h-16 w-16 rounded-lg bg-slate-100 shrink-0" />}
            <div className="min-w-0 flex-1">
              <p className="text-xs font-bold text-slate-700">{fmtD(w.weekStart)} ~ {fmtD(w.weekEnd)}<span className="ml-2 text-[10px] text-slate-400 font-normal">{T(`${w.days} 天 · ${w.crewDays} 人次 · ${w.inspections} 次巡检${w.fixed ? ` · ${w.fixed} 项整改闭环` : ""}`, `${w.days}d · ${w.crewDays} crew-days · ${w.inspections} insp.`)}</span></p>
              <p className="text-[12px] text-slate-600 mt-0.5 line-clamp-2">{pickSummary(w, lang)}</p>
              {w.feedback && (w.feedback.like || w.feedback.comment) && (
                <p data-testid={`owner-weekly-feedback-${w.weekStart}`} className="text-[11px] text-emerald-700 mt-1 inline-flex items-center gap-1">
                  {w.feedback.like && <ThumbsUp className="h-3 w-3" />}{w.feedback.like ? T("已点赞", "Liked") : ""}{w.feedback.comment ? ` · 「${w.feedback.comment}」` : ""}
                </p>
              )}
              <p className="text-[10px] text-red-600 mt-1 inline-flex items-center gap-1"><Share2 className="h-3 w-3" />{T("查看并分享", "View & share")}<ExternalLink className="h-3 w-3" /></p>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
};
